import { useTheme, css } from "@emotion/react";
import PropTypes from "prop-types";
import { em } from "@util/convertUnits";
import React, { useState } from "react";
import CmsImageLoader from "../../../base/CmsImageLoader";
import {ButtonPill} from "@/base";
import useWindowResized from "@/helpers/useWindowResized";

const SwatchesWidget = ({ content }) => {

    const theme = useTheme();
    const [isMobile, setIsMobile] = useState(window.innerWidth <= theme.breakpoint.ns )
    const [isOpen, setIsOpen] = useState(false)

    useWindowResized(() => {
        let mobileCheck = window.innerWidth <= theme.breakpoint.ns;
        if (isMobile !== mobileCheck) setIsMobile(mobileCheck);
    })

    const subheaderCss = css(`
        text-align:center;
        display: flex;
        justify-content: center;
        margin-top: 2em;
        margin-bottom: 1em;
        @media (min-width: ${em(theme.breakpoint.ns, 16)}) {
            margin-bottom: 2em;

            + p{
                margin-top: -2em;
            }
        }
    `)

    const swatchWrapperCss = css(`
        position: relative;
        display:flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: center;
        margin-bottom:2em;
        @media (min-width: ${em(theme.breakpoint.ns, 16)}) {
            width: 100%;
            max-width: 840px;
        }
    `);

    const labelStyles = css(`
        font-size: 12px;
        margin-top: 5px;
    `);

    const descriptionCss = css(`
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 2.5em;
        max-width:90%;
        text-align:center;
 
    `);

    const listItemCss = css(`
        
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: start;
        text-align: center;
        margin-bottom: 1em;
        width: 120px;
        
    `)

    const swatchContainer = css(`
        text-align: center;
        width: 100%%;
        display: flex;
        flex-direction: column;
        align-items: center;
    `);

    const fadeCss = css(`
        position: absolute;
        bottom: 0px;

        display: block;
    
        width: 100%;
        height: 10em;
    
        background-image: linear-gradient(to bottom, 
            rgba(255, 255, 255, 0), 
            rgba(255, 255, 255, 0.9)
        80%);
    `);

    const labelDescriptionContainer = css(`
            display: flex;
            align-items:center;
            justify-content:center;
            flex-direction: column;
    `);

    const swatchImageCss = css(`
        border-radius: 50%;
        height: 60px;
        width: 60px;
    `)

    const { swatches, label, description, footnote_label, footnote } = content;


    const swatchesDom = swatches?.map((swatch, swatchIndex) => {
        if(isMobile && swatchIndex >= 6 && !isOpen ) return;
        return (
            <div key={`${swatch.swatch_url}_${swatch.swatch_label}`} css={listItemCss}>
                <CmsImageLoader css={swatchImageCss}
                                url={swatch.swatch_url}
                                alt={swatch.alt_text} />
                <div css={labelStyles}>{swatch.swatch_label}</div>
            </div>
        )

    })


    return <div css={labelDescriptionContainer} className={'pb-4'}>
        {label ? <h4 css={subheaderCss}> {label}</h4> : null}
        {description ? <p css={descriptionCss}>{description}</p> : null}
        <div css={swatchContainer}>
            <div css={swatchWrapperCss}>
                {swatchesDom}

                { isMobile && swatches?.length > 6 && !isOpen ? <div css={fadeCss}></div> : ""}

            </div>

            { isMobile && swatches?.length > 6 &&  (
                <ButtonPill buttonTheme={'dark-rev'} onClick={() => setIsOpen(!isOpen)}>{ isOpen ? 'View Less' : 'View More'}</ButtonPill>
            )}
            {footnote_label ? <h5 css={subheaderCss}> {footnote_label}</h5> : null}
            {footnote ? <React.Fragment>
                {[].concat(footnote).map(notes => {
                    if(!notes) return null;
                    return <p key={notes} css={descriptionCss}>{notes}</p>
                })}
            </React.Fragment> : null}
        </div>

    </div>;
};

SwatchesWidget.propTypes = {
    content: PropTypes.object,
    swatches: PropTypes.object,
    isOpen: PropTypes.bool,
};
export default SwatchesWidget;